import {Descriptions, Form, Input, Button, Space, Tooltip} from 'antd'
import {useEffect, useMemo} from 'react'
import {ExclamationCircleOutlined, FileTextOutlined, ReloadOutlined, SearchOutlined} from '@ant-design/icons'
import useGetCheckDetailProductList from '../hooks/useGetCheckDetailProductList'
import useGetProductTransfersAmountText from "../hooks/useGetProductTransfersAmountText";
import ProductTransfersList from './ProductTransfersList'
import moment from 'moment'
import {getNumProduct, plusMumber} from "../../../@utils";

const desMap = [
  { name: '调出门店', key: 'sourceStoreName' },
  { name: '调入门店', key: 'destStoreName' },
  { name: '经手人', key: 'handlerName' },
  {
    name: '创建时间',
    key: 'createTime',
    formate: val => moment(val).format('YYYY-MM-DD HH:mm')
  },
]

const useGetDisplayDataByList = (list = []) => {
  const { checkProductTypeNum, totalQuantity, totalCostPrice } =
    useMemo(() => {
      let totalQuantity = 0,
        totalCostPrice = 0
      if (list.length > 0) {
        list.map(item => {
          totalQuantity += (item.quantity || 0) - 0
          totalCostPrice += getNumProduct(item.quantity, item.costPrice)
        })
      }
      return {
        checkProductTypeNum: list.length,
        totalQuantity: totalQuantity,
        totalCostPrice: totalCostPrice
      }
    }, [list])
  return {
    checkProductTypeNum,
    totalQuantity,
    totalCostPrice
  }
}

export default function TransfersDetail({ detail = {}, type = 'in' }) {
  const tableColums = [
    {
      title: `调${type=='in'?'入':'出'}数量`,
      dataIndex: 'quantity',
      formatter: val => {
        val = val && Math.abs(parseInt(val))
        if (val) {
          return val > maxCount ? maxCount : val
        }
      }
    },
    {
      title:  () => (
        <Tooltip title={`调${type=='in'?'入':'出'}总额=成本价*调${type=='in'?'入':'出'}数量`}>
          <div>
            <span style={{ marginRight: '6px' }}>{`调${type=='in'?'入':'出'}总额`}</span>
            <ExclamationCircleOutlined style={{ fontSize: '12px' }} />
          </div>
        </Tooltip>
      ),
      dataIndex: 'quantityTakeCostPrice',
      render:(text, record)=> (record.quantity *record.costPrice).toFixed(2)
    },
  ]
  const displayData = useGetDisplayDataByList(detail.products || [])
  const { amountInfoText } = useGetProductTransfersAmountText(displayData)
  const descriptionTitle = (
    <>
      <FileTextOutlined style={{color: '#1890ff'}} />
      <span style={{ marginLeft: '8px',color: '#1890ff' }}>
        商品调拨单：{detail.no}
      </span>
    </>
  )
  return (
    <>
      <Descriptions title={descriptionTitle}>
        {desMap.map((item, index) => (
          <Descriptions.Item key={index} label={item.name}>
            {item.formate ? item.formate(detail[item.key]) : detail[item.key]}
          </Descriptions.Item>
        ))}
        <Descriptions.Item label="备注">
          {type == 'out'?detail['note']: detail['inwardNote']}
        </Descriptions.Item>
      </Descriptions>
      <div style={{ marginTop: '20px' }}></div>
      <ProductTransfersList page={false} tableColums={tableColums} unit="packageUnitName" list={detail.products}/>
      {amountInfoText}
    </>
  )
}
